import { PhotoSwipeLightbox } from "vendor";

(() => {
  if (window.O7CommunityGallery) return;
  window.O7CommunityGallery = true;

  const closeSvg = `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
    <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
    <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
    <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
  </svg>`;

  const updateCaption = (el, pswp) => {
    const captionEl = el.querySelector("[data-o7-gallery-caption]");
    if (!captionEl) return;
    const caption = pswp.currSlide?.data?.caption || pswp.currSlide?.data?.alt || "";
    captionEl.textContent = caption;
    captionEl.hidden = !caption;
  };

  const createLightbox = () => {
    const photoswipe = new PhotoSwipeLightbox({
      pswpModule: () => import("photoswipe"),
      bgOpacity: 1,
      maxZoomLevel: 3,
      closeTitle: window.themeVariables?.strings?.closeGallery || "Close",
      zoomTitle: window.themeVariables?.strings?.zoomGallery || "Zoom",
      errorMsg: window.themeVariables?.strings?.errorGallery || "The image could not be loaded.",
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      zoom: false,
      closeSVG: closeSvg
    });

    photoswipe.addFilter("thumbEl", (thumbEl, data) => data.thumbnailElement || thumbEl);

    photoswipe.on("uiRegister", () => {
      photoswipe.pswp.ui.registerElement({
        name: "bottom-bar",
        order: 5,
        appendTo: "wrapper",
        html: `
          <div class="o7-cgal-pswp__footer">
            <p class="o7-cgal-pswp__caption" data-o7-gallery-caption hidden></p>
            <div class="pagination">
              <button class="pagination__item group" rel="prev" type="button">
                <span class="animated-arrow animated-arrow--reverse"></span>
              </button>
              <span class="pagination__current text-sm">
                <span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span>
              </span>
              <button class="pagination__item group" rel="next" type="button">
                <span class="animated-arrow"></span>
              </button>
            </div>
          </div>
        `,
        onInit: (el, pswp) => {
          el.querySelector(".pagination__page-count").innerText = pswp.getNumItems();
          el.querySelector('[rel="prev"]')?.addEventListener("click", () => pswp.prev());
          el.querySelector('[rel="next"]')?.addEventListener("click", () => pswp.next());
          updateCaption(el, pswp);
          pswp.on("change", () => {
            el.querySelector(".pagination__current-page").innerText = pswp.currIndex + 1;
            updateCaption(el, pswp);
          });
        }
      });
    });

    photoswipe.init();
    return photoswipe;
  };

  const setup = (root) => {
    if (!root || root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    const triggers = [...root.querySelectorAll("[data-o7-gallery-open]")];
    if (!triggers.length) return;

    let photoswipe;

    const openAt = (index) => {
      const dataSource = triggers.map((trigger) => {
        const image = trigger.querySelector("img");
        const caption = trigger.dataset.caption || image?.alt || "";
        return {
          thumbnailElement: image,
          src: trigger.dataset.src || image?.currentSrc || image?.src,
          srcset: image?.srcset,
          msrc: image?.currentSrc || image?.src,
          width: Number.parseInt(trigger.dataset.width || image?.getAttribute("width") || "1600", 10),
          height: Number.parseInt(trigger.dataset.height || image?.getAttribute("height") || "2000", 10),
          alt: caption,
          caption
        };
      });

      photoswipe = photoswipe || createLightbox();
      photoswipe.loadAndOpen(index, dataSource);
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        openAt(index);
      });
    });
  };

  document.querySelectorAll("[data-o7-gallery]").forEach(setup);
  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector("[data-o7-gallery]");
    if (root) {
      root.dataset.ready = "false";
      setup(root);
    }
  });
})();
